import React, { useEffect, useState } from "react";
import { getDriverDeliveryGroups } from "api/deliveries";
import { DeliveryGroup } from "typings/models";
import { CircularProgress, Accordion, AccordionSummary, AccordionDetails, Typography, Box, Table, TableBody, TableCell, TableContainer, TableRow, Paper } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTravelContext } from "misc/TravelContext";
import { Button } from "@mui/material";

interface DeliveredRoutesPageProps {
    setStep: (step: string) => void;
}

const DeliveredRoutesPage: React.FC<DeliveredRoutesPageProps> = ({ setStep }) => {
    const [deliveryGroups, setDeliveryGroups] = useState<DeliveryGroup[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { driver,
        setDriver,
        setRoute,
        setOrder,
        setDeliveryGroup,

     } = useTravelContext();
    

    useEffect(() => {
        const fetchDeliveryGroups = async () => {
            const deliveryGroups = await getDriverDeliveryGroups();
            setDeliveryGroups(deliveryGroups);
            setLoading(false);
        };
        fetchDeliveryGroups();
    }, []);

    const colorMap = {
        "Completed": "green",
        "In Progress": "blue",
        "Cancelled": "red",
        "Failed": "red",
        "Not Started": "gray"
    }

    return (
        <Box sx={{ padding: 2 }}>

            {loading ? <CircularProgress /> : (
                deliveryGroups.map((deliveryGroup) => (
                    <Accordion key={deliveryGroup.id}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography 
                                variant="h6"
                                sx={{
                                    color: colorMap[deliveryGroup.status],
                                    width: "100%"
                                }}
                            >
                                {new Date(deliveryGroup.created_at).toLocaleDateString("en-CA")}
                                &nbsp; | &nbsp;
                                { deliveryGroup.deliveries.length} { deliveryGroup.deliveries.length === 1 ? "Orden" : "Órdenes"}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Box display="flex" justifyContent="center" width="100%">
                            <Button 
                                onClick={() => {
                                    console.log("deliveryGroup", deliveryGroup);
                                    setDeliveryGroup(deliveryGroup);
                                    setStep("delivery");
                                }}
                                color="primary"
                                size="small"
                                variant="contained"
                                sx={{ marginBottom: 2 }}
                            >
                                {
                                    deliveryGroup.status === "Completed" ? "Ver Ruta" : "Continuar Ruta"
                                }
                            </Button>
                        </Box>
                            {deliveryGroup.deliveries.map(delivery => (
                                <TableContainer component={Paper} key={delivery.id} sx={{ marginBottom: 2 }}>
                                    <Table>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell><strong>No. Orden</strong></TableCell>
                                                <TableCell>{delivery.order.id}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell><strong>Estado</strong></TableCell>
                                                <TableCell>{delivery.status}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell><strong>Fecha de Entrega</strong></TableCell>
                                                <TableCell>{new Date(delivery.delivery_time).toLocaleDateString()}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                ))
            )}
        </Box>
    );
};

export default DeliveredRoutesPage;
